import React, { ComponentType } from 'react';

import { withHeaderState } from '@bingads-webui-campaign-react/overview-card';

import { State, FilterDataProps, CompetitionCardProps } from '../utils/types';

export function withFilterData<P extends CompetitionCardProps>(WrappedComponent: ComponentType<P>) {
  const HoC = (props: Omit<P, keyof FilterDataProps> & { headerState?: State }) => {
    const { headerState, isLoading } = props;
    return (<WrappedComponent
      {...props as any}
      selectedMetric={headerState?.metric}
      competitors={headerState?.competitors}
      isLoading={isLoading || !headerState}
    />);
  };
  HoC.defaultProps = {
    headerState: undefined,
  };
  return withHeaderState(HoC);
}
